/* eslint-disable jsx-a11y/anchor-has-content */
import Trans from 'next-translate/Trans'

import { UserHelpCenterUrl } from '~/constants'

export const ErrorComp = () => {
  return (
    <h1 className='text-body-text-1 text-center'>
      <MiscReloadError />
    </h1>
  )
}

export const ForceLogoutError = () => {
  return (
    <h1 className='text-body-text-1 text-center'>
      <Trans
        i18nKey={'common.errorMessages.forceLogoutError'}
        components={{
          p: <p className='text-body-text-1' />,
          b: <strong />,
          HelpLink: <a className='underline' href={UserHelpCenterUrl} />,
        }}
        /* Include fallback text error about being offline in English as translations don't work offline */
        fallback="Looks like you're offline! Please check your internet connection and try again."
      />
    </h1>
  )
}

export const MiscReloadError = () => {
  return (
    <Trans
      i18nKey={'common.errorMessages.miscReloadError'}
      components={{
        p: <p className='text-body-text-1' />,
        b: <strong />,
        HelpLink: <a className='underline' href={UserHelpCenterUrl} />,
        HomeLink: <a className='underline' href={'/'} />,
      }}
      /* Include fallback text error about being offline in English as translations don't work offline */
      fallback="Looks like you're offline! Please check your internet connection and try again."
    />
  )
}

export const ActionButton = ({ children, ...rest }: React.ComponentProps<'button'>) => {
  return (
    <button
      className='text-body-text-2 text-text-interactive underline capitalize font-light hover:font-normal'
      {...rest}
    >
      {children}
    </button>
  )
}

/* use a instead of next/link as we don't want to prefetch on hover */
export const ActionLink = ({ children, ...rest }: React.ComponentProps<'a'>) => {
  return (
    <a className='text-body-text-2 text-text-interactive underline capitalize font-light hover:font-normal' {...rest}>
      {children}
    </a>
  )
}
